import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DeviceIdService } from '@ridango/core/lib/services';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CartTicketRequest } from '@ridango/components/lib/purchase/purchase.model';
import { takeUntil } from 'rxjs/operators';
import { ShoppingCartService } from '@ridango/components';
import { BaseComponent } from '@ridango/core';

@Component({
    selector: 'rwidget-anonymous-user-modal-to-shopping-cart',
    templateUrl: '../anonymous-user-modal.component.html'
})
export class AnonymousUserModalToShoppingCartComponent extends BaseComponent implements OnInit, OnDestroy {
    private routeParams: string[] = ['purchase-v2', 'cart'];
    private ticket: CartTicketRequest;

    constructor(
        public dialogRef: MatDialogRef<AnonymousUserModalToShoppingCartComponent>,
        private translate: TranslateService,
        private router: Router,
        private deviceIdService: DeviceIdService,
        private shoppingCartService: ShoppingCartService,
        @Inject(MAT_DIALOG_DATA) public data: { ticket: CartTicketRequest; routeParams: string[] }
    ) {
        super();
    }

    ngOnInit() {
        if (this.data?.ticket) {
            this.ticket = this.data.ticket;
        }
        if (this.data?.routeParams) {
            this.routeParams = this.data.routeParams;
        }
    }

    cancel(): void {
        this.dialogRef.close();
    }

    register() {
        this.router.navigate([this.translate.currentLang, 'register']);
        this.cancel();
    }

    login() {
        this.deviceIdService.setLocalUserExist(true);
        if (this.deviceIdService.getAccessDeviceToken()) {
            const cleanTicket: CartTicketRequest = {
                productId: this.ticket.productId,
                startZoneId: this.ticket.startZoneId,
                endZoneId: this.ticket.endZoneId,
                email: this.ticket.email
            };

            this.shoppingCartService
                .addProductToCartV2({ shoppingCartId: null, tickets: [cleanTicket] })
                .pipe(takeUntil(this.componentDestroyed$))
                .subscribe(() => {
                    this.router.navigate([this.translate.currentLang, ...this.routeParams]);
                    this.cancel();
                });
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
